var data = {
	"body": "<path d=\"M342 64l6 1h83v96h-83q-7 0-13.5 1t-10.5 3.5t-7.5 5.5t-6 6t-4 6.5t-2 6l-1 5l-.5 3.5v154h162l-23 96H303v480h-96V448H79v-96h128V203q0-31 8-55.5t21.5-38.5T264 85t31-14t27-5.5t20-1.5zm89 1zM342 0q-62 0-111 30q-88 53-88 173v85H79q-26 0-45 19t-19 45v96q0 26 19 45t45 19h64v415q0 27 18.5 45.5T207 991h96q26 0 45-18.5t19-45.5V512h75q22 0 39-13t23-33l22-96q9-31-10-56.5T465 288h-98v-63h64q26 0 45-19t19-45V65q0-27-18.5-45.5T432 1h-82q-4-1-8-1z\" fill=\"currentColor\"/>",
	"width": 528,
	"height": 992
};
exports.__esModule = true;
exports.default = data;
